import script from "./AssembleeGenerale.vue?vue&type=script&setup=true&lang=js"
export * from "./AssembleeGenerale.vue?vue&type=script&setup=true&lang=js"

import "./AssembleeGenerale.vue?vue&type=style&index=0&id=1b99e80a&scoped=true&lang=css"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b99e80a"]])

export default __exports__